<template>
  <v-textarea
    v-bind="$attrs"
    v-on="$listeners"
    :label="attribute.mandatory ? ($attrs.label + ' *') : $attrs.label"
    :rules="rules"
    :counter="attribute.maxLength"
    :rows="1"
    auto-grow
  ></v-textarea>
</template>

<script>
export default {
  name: 'LongTextAttribute',
  props: {
    attribute: {
      type: Object,
      required: true
    }
  },
  computed: {
    rules () {
      const list = []
      if (this.attribute.mandatory) {
        list.push((v) => !!v || `${this.$attrs.label} är obligatorisk`)
      }
      if (this.attribute.maxLength) {
        list.push((v) => (!v || v.length <= this.attribute.maxLength) || `Du kan ange max ${this.attribute.maxLength} tecken i detta fält`)
      }
      return list
    }
  }
}
</script>
